import * as React from 'react';
import './page.css';

export const pageHabitat: React.StatelessComponent<{}> = ({ children }) => {
  return <div className="s-page-habitat">{children}</div>;
};
